import React from 'react';

import { Chip } from '@mui/material';
import length from '@turf/length';
import { useTranslation } from 'react-i18next';

import { humanLength } from '../../utils/utils';

const DistanceChip = ({children}) => {
  return (
    <Chip sx={{borderRadius: 0, color: '#FFFFFF', backgroundColor: '#000000'}} label={children} />
  );
};

export const LengthBadgeFeature = ({ feature }) => {

  const { t } = useTranslation();
  if (feature === undefined) {
    return(<></>);
  }

  const featureLength = length(feature) * 1000;
  return (
    <DistanceChip>
      <span className='hidden'>{t('stepPath.distance_label')} :</span>
      <span>{humanLength(featureLength)}</span>
    </DistanceChip>
  );
};

export const LengthBadgeValue = ({ value }) => {
  return (
    <Chip label={humanLength(value)} />
  );
};

